<template>
  <div>
    <CRow>
      <CCol><h3>Get Role</h3></CCol>
      <CCol>
        <router-link to="/roles">
          <CButton color="primary" class="float-right">
            Back to role list
          </CButton></router-link
        >
      </CCol>
    </CRow>
    <CAlert color="danger" closeButton :show.sync="alert.show">
      {{ alert.text }}
    </CAlert>
    <CRow>
      <CCol>
        <CCard class="w-100">
          <CCardBody v-if="!loading.role">
            <CCardTitle>{{ role.name }} - Permissions</CCardTitle>
            <TheTable :fields="fields" :items="permissions"></TheTable>
          </CCardBody>
          <div class="my-5 text-center" v-else>
            <CSpinner color="info" size="sm"></CSpinner>
          </div>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CCard class="w-100">
          <CCardBody v-if="!loading.users">
            <CCardTitle>Users with role</CCardTitle>
            <CListGroup v-if="roleUsers.users" :flush="true">
              <div v-for="(user, index) in roleUsers.users" :key="user.user_id">
                <CListGroupItem>
                  <strong>{{ index + 1 }}.</strong> {{ user.name }} ({{
                    user.email
                  }})
                </CListGroupItem>
              </div>
            </CListGroup>
          </CCardBody>
          <div class="my-5 text-center" v-else>
            <CSpinner color="info" size="sm"></CSpinner>
          </div>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TheTable from "./../containers/TheTable";
export default {
  name: "GetRole",
  components: {
    TheTable,
  },
  data() {
    return {
      roleUsers: {},
      role: {},
      permissions: null,
      loading: {
        role: false,
        users: false,
      },
      alert: {
        show: false,
        text: "",
      },
      fields: [
        {
          key: "permission_name",
          label: "Permission Name",
          //_style: "width:40%"
        },
        {
          key: "description",
          label: "Description",
          //_style: "width:40%"
        },
        {
          key: "resource_server_name",
          label: "API Name",
          //_style: "width:40%"
        },
        {
          key: "resource_server_identifier",
          label: "API Identifier",
          //_style: "width:40%"
        },
      ],
    };
  },
  created() {
    if (this.$route.params.role_id) {
      this.getRoleInfo();
      this.getRoleUserList();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    ...mapActions(["getRoleById", "getRoleUsers", "getRolePermissionsById"]),
    async getRoleInfo() {
      this.loading.role = true;
      let roleResponse = await this.getRoleById(this.$route.params.role_id);
      let permissionsResponse = await this.getRolePermissionsById(
        this.$route.params.role_id
      );

      if (!roleResponse.error && !permissionsResponse.error) {
        this.role = roleResponse.data;
        this.permissions = permissionsResponse.data;
      } else {
        if (roleResponse.error) {
          this.alert.show = true;
          this.alert.text = roleResponse.error_details.message;
        } else {
          this.alert.show = true;
          this.alert.text = permissionsResponse.error_details.message;
        }
      }
      this.loading.role = false;
    },

    async getRoleUserList() {
      this.loading.users = true;
      let response = await this.getRoleUsers({
        id: this.$route.params.role_id,
        params: {
          include_totals: true,
          per_page: 100,
        },
      });
      if (!response.error) this.roleUsers = response.data;
      if (response.error) {
        this.alert.show = true;
        this.alert.text = response.error_details.message;
      }
      this.loading.users = false;
    },
  },
};
</script>

<style></style>
